import type { HelpRequestView } from "./help-model.js";

type T = (k: string, p?: Record<string, string | number>) => string;

/** Short, stable disambiguator for a DID — its last 4 characters. No human
 *  display-name system exists, so this is how two helpers stay distinct. */
export function didSuffix(did: string): string {
  return did.slice(-4);
}

/** Human label for a coordination-thread author, derived from the request's
 *  creator/acceptedHelpers. "You" for self, "Requester" for the creator,
 *  "Helper · <suffix>" for an accepted helper, else a bare suffix (defensive;
 *  should not occur under the closed-membership model). */
export function participantLabel(did: string, view: HelpRequestView, me: string, t: T): string {
  if (did === me) return t("help.thread.you");
  if (did === view.creator) return t("help.thread.requester");
  if (view.acceptedHelpers.includes(did)) return t("help.thread.helper", { id: didSuffix(did) });
  return didSuffix(did);
}
